import { MethodParameters } from '@btcdirect/shared/src/types';
import { Theme } from '@btcdirect/stores';
import { I18n } from 'vue-i18n';

/**
 * Embeddable instance types
 *
 * This list consists of all widgets that are allowed to run separately. So authentication is not needed here.
 */
export const enum InstanceTypes {
    AUTHENTICATION = 'authentication',
    COIN_TO_FIAT = 'coin-to-fiat',
    DOLLAR_COST_AVERAGE = 'dollar-cost-average',
    FIAT_TO_COIN = 'fiat-to-coin',
    ONBOARDING = 'onboarding',
    TRANSACTION_HISTORY = 'transaction-history',
    LEDGER_INTEGRATION = 'ledger'
}

/**
 * Configuration that is used throughout the embeddables.
 */
export interface Configuration {
    selector: string;
    enableUserIdentifier?: boolean;
    returnUrl?: string;
    useFullWidth?: boolean;
    useSameWindowForPayment?: boolean;
    theme?: Theme;
    type: InstanceTypes;
    version: 'v1' | 'v2';
}

/**
 * Configuration that can be provided during initialization of the embeddables.
 */
export interface InstanceConfiguration extends Configuration {
    token: string;
    debug?: boolean;
    locale?: string;
    userIdentifier?: string;
    walletConfirmationRequired?: boolean;
    startInOverview?: boolean;
    hideFooter?: boolean;
    isUnifiedCheckout?: boolean;
}

/**
 * Represents the instance data
 */
export interface Instance {
    name: string;
    queue: MethodQueue;
    config: InstanceConfiguration;
    i18n?: I18n;
}

/**
 * Represents the queue of methods to execute.
 */
export type MethodQueue = Array<[method: string, parameters: MethodParameters]>;
